document.addEventListener('DOMContentLoaded', function () {
  // Only run on homepage
  if (!document.body.classList.contains('template-index') &&
      !document.body.classList.contains('index')) {
    // Fallback check via URL path
    if (window.location.pathname !== '/' && !window.location.pathname.match(/^\/?$/)) {
      return;
    }
  }

  const sections = document.querySelectorAll('#MainContent > .shopify-section, main > .shopify-section');

  if (!sections.length) return;

  sections.forEach(section => section.classList.add('reveal-on-scroll'));

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  sections.forEach(section => observer.observe(section));
});